import { isEmpty, omit, uniq } from "lodash"
import React, { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { X } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"
import Select from "react-select"
import Flag from "react-world-flags"
import shortId from "shortid"
import CheckIcon from "../../../assets/check.svg"
import TrashIcon from "../../../assets/trash.svg"
import { SERVICE_TYPE } from "../../../constants/constants"
import { insert } from "../../../utils/commonFunctions"

const UpdateOrCreateShippingDiscount = ({
    variationData,
    setVariationData,
    selectedWarehouse,
    shippingServices,
    customer,
    countryList,
    addedRateSlabs,
    setAddedRateSlabs,
    // addedDiscounts,
    // setAddedDiscounts,
    // rateSlabs,
    handleSubmit,
    setSelectedWarehouse,
    setUpdateModalWarehouse,
    setShowConfirmModal,
    rateSlabType,
    customerShippingRates
}: {
    variationData: Record<string, any>
    setVariationData: Function
    selectedWarehouse: Record<string, any>
    shippingServices: Record<string, any>[]
    customer: Record<string, any>
    countryList: Record<string, any>[]
    addedRateSlabs: Record<string, any>[]
    setAddedRateSlabs: Function
    // addedDiscounts: Record<string, any>[]
    // setAddedDiscounts: Function
    // rateSlabs: Record<string, any>[]
    handleSubmit: Function
    setSelectedWarehouse: Function
    setUpdateModalWarehouse: Function
    setShowConfirmModal: Function
    rateSlabType: string
    customerShippingRates: Record<string, any>[]
}) => {
    const { t } = useTranslation()
    const [discountValues, setDiscountValues] = useState([] as Record<string, any>[])
    useEffect(() => {
        if (variationData?.countries?.length > 0) {
            variationData?.countries?.forEach((d: string) => {
                document?.getElementById(`${d}-country`)?.classList?.add("d-none")
            })
        }
    }, [variationData?.countries?.length])

    useEffect(() => {
        let tempDiscounts = []
        if (addedRateSlabs?.length > 0) {
            tempDiscounts = addedRateSlabs.map((addedRateSlab: Record<string, any>, index: number) =>
                omit(
                    {
                        ...addedRateSlab,
                        discount: addedRateSlab?.discount_value,
                        id: shortId.generate()
                    },
                    "discount_value"
                )
            )
            setDiscountValues([...tempDiscounts])
        } else {
            setDiscountValues([])
        }
    }, [addedRateSlabs?.length])
    return (
        <tr className="rounded">
            <td className="col-1">
                <Flag className={"w-50 d-inline"} code={selectedWarehouse?.country} />
                &nbsp;&nbsp;{selectedWarehouse?.country}
            </td>
            <td className="col-3">
                {/* <Select
                    name="shippingService"
                    options={shippingServices?.map(
                        (sc: Record<string, any>) => { return { value: sc?.shipping_service, label: sc?.shipping_service?.replaceAll("_", " ").toLowerCase() } }
                    )}
                    defaultValue={
                        variationData?.shipping_service && 
                        { 
                            value: variationData?.shipping_service,
                            label: variationData?.shipping_service?.replaceAll("_", " ")?.toLowerCase()
                        }
                    }
                    isDisabled={!!variationData?.id}
                    className="basic-multi-select text-capitalize"
                    classNamePrefix="select"
                    onChange={(service: SingleValue<Record<string, any>>) => setVariationData({ ...variationData, shipping_service: service?.value })}
                /> */}
                <Form.Select
                    disabled={!!variationData?.id}
                    value={variationData?.shipping_service_id}
                    className="text-capitalize"
                    placeholder={t("Select a shipping service...")}
                    onChange={(e: any) =>
                        setVariationData({
                            ...variationData,
                            // shipping_service: e?.target?.value?.replaceAll(" ", "_").toLowerCase(),
                            shipping_service_id: e?.target?.value
                        })
                    }>
                    <option placeholder="Select a shipping service">Select a shipping service</option>
                    {shippingServices
                        ?.filter(
                            (ss) =>
                                !customerShippingRates?.map((cs) => cs?.shipping_service_id).includes(ss?.id) &&
                                Number(ss?.warehouse_id) === Number(selectedWarehouse?.id)
                        )
                        .map((shippingService: Record<string, any>) => (
                            <option value={shippingService?.id} key={shippingService?.shipping_service}>
                                {shippingService?.shipping_service?.replaceAll("_", " ").toLowerCase()}
                            </option>
                        ))}
                </Form.Select>
            </td>
            <td className="col-2">
                <Select
                    isMulti
                    name="destinations"
                    defaultValue={
                        !variationData?.id
                            ? [{ value: customer?.country, label: customer?.country }]
                            : variationData?.countries?.map((c: string) => {
                                  return { value: c, label: c }
                              })
                    }
                    options={countryList?.map((c) => {
                        return {
                            value: c?.iso2_code,
                            label: (
                                <>
                                    <span id={`${c?.iso2_code}-country`}>{c?.name}-</span>
                                    <span>{c?.iso2_code}</span>
                                </>
                            )
                        }
                    })}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(destinations) => {
                        setVariationData({
                            ...variationData,
                            countries: uniq(destinations)?.map((s) => s?.value)
                        })
                    }}
                />
            </td>
            <td className="col-3">
                {discountValues?.map((s: Record<string, any>, index: number) => (
                    <div
                        className="d-flex align-items-center justify-content-between mb-4"
                        key={`${s.id}-discount-update`}>
                        <Form.Control
                            type="number"
                            className="mb-2 form-control small-placeholder px-0"
                            min="0"
                            max={s?.max_weight || null}
                            value={s?.min_weight}
                            placeholder="From"
                            onChange={(e: Record<string, any>) => {
                                const newDiscounts = discountValues?.filter((_) => _.id !== s.id)
                                insert(newDiscounts, index, {
                                    ...s,
                                    min_weight: parseFloat(e.target.value) || 0
                                })
                                setDiscountValues([...newDiscounts])
                            }}
                        />
                        &nbsp;&nbsp;-&nbsp;&nbsp;
                        <Form.Control
                            type="number"
                            className="mb-2 form-control small-placeholder px-0"
                            min={s?.min_weight || 0}
                            value={s?.max_weight}
                            placeholder="To"
                            onChange={(e: Record<string, any>) => {
                                const newDiscounts = discountValues?.filter((_) => _.id !== s.id)
                                insert(newDiscounts, index, {
                                    ...s,
                                    max_weight: parseFloat(e.target.value) || 0
                                })
                                setDiscountValues([...newDiscounts])
                            }}
                        />
                        &nbsp;&nbsp;{s?.weight_unit}&nbsp;&nbsp;
                    </div>
                ))}
                <Button
                    className="dashed-border w-100"
                    onClick={() => {
                        setDiscountValues([
                            ...discountValues,
                            {
                                weight_unit: selectedWarehouse?.weight_unit,
                                id: shortId.generate()
                            } as Record<string, any>
                        ])
                    }}>
                    + {t("Add Range")}
                </Button>
            </td>
            <td className="col-2 text-center">
                {discountValues?.map((d: Record<string, any>, index: number) => {
                    return (
                        <Row className="align-items-start" key={`${d?.id}-discount-new`}>
                            {/* <input
                            type="number"
                            className="w-50 mb-2 form-control"
                            min="0"
                            max="100"
                            value={d?.discount}
                            onChange={(e) => {
                                const newDiscounts = discountValues?.filter(_ => _.id !== d.id)
                                insert(newDiscounts, index, {
                                    ...d,
                                    discount: parseFloat(e.target.value) || 0
                                })
                                setDiscountValues([...newDiscounts])
                            }}
                        /> */}
                            <Col lg={12}>
                                <Row className="align-items-center">
                                    <Col lg={10}>
                                        <Form.Control
                                            type="number"
                                            autoComplete="off"
                                            className="mb-2 form-control small-placeholder"
                                            value={d?.discount}
                                            onChange={(e: Record<string, any>) => {
                                                const newDiscounts = discountValues?.filter(
                                                    (_) => _.id !== d.id
                                                )
                                                insert(newDiscounts, index, {
                                                    ...d,
                                                    discount: parseFloat(e.target.value) || 0,
                                                    discount_type:
                                                        d?.discount_type && d?.discount_type !== ""
                                                            ? d?.discount_type
                                                            : SERVICE_TYPE["0"]
                                                })
                                                setDiscountValues([...newDiscounts])
                                            }}
                                            placeholder={
                                                !d?.discount_type || d?.discount_type === SERVICE_TYPE["1"]
                                                    ? "Discount"
                                                    : "Rate"
                                            }
                                        />
                                        {/* <small className="mx-2">
                                { d?.discount_type && d?.discount_type === SERVICE_TYPE["0"] 
                                || rateSlabType === SERVICE_TYPE["0"]
                                ? t("$/lb") : t("%")}
                            </small> */}
                                    </Col>
                                    <Col lg={2} className="">
                                        <X
                                            onClick={() => {
                                                const newDiscounts = discountValues?.filter(
                                                    (_) => _.id !== d.id
                                                )
                                                setDiscountValues([...newDiscounts])
                                            }}
                                            className="tr-pointer text-muted"
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Check
                                            type="radio"
                                            label={t("%")}
                                            onChange={(e: any) => {
                                                if (e?.target?.checked) {
                                                    const newDiscounts = discountValues?.filter(
                                                        (_) => _.id !== d.id
                                                    )
                                                    insert(newDiscounts, index, {
                                                        ...d,
                                                        discount_type: SERVICE_TYPE["1"]
                                                    })
                                                    setDiscountValues([...newDiscounts])
                                                }
                                            }}
                                            required={true}
                                            checked={d?.discount_type === SERVICE_TYPE["1"]}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Check
                                            type="radio"
                                            label={t("$")}
                                            onChange={(e: any) => {
                                                if (e?.target?.checked) {
                                                    const newDiscounts = discountValues?.filter(
                                                        (_) => _.id !== d.id
                                                    )
                                                    insert(newDiscounts, index, {
                                                        ...d,
                                                        discount_type: SERVICE_TYPE["0"]
                                                    })
                                                    setDiscountValues([...newDiscounts])
                                                }
                                            }}
                                            required={true}
                                            checked={d?.discount_type === SERVICE_TYPE["0"]}
                                        />
                                    </Col>
                                </Row>
                                {/* <InputGroup.Text
                                className="custom-input-text tr-pointer"
                                onClick={() => {
                                    const newDiscounts = discountValues?.filter(_ => _.id !== d.id)
                                    insert(newDiscounts, index, {
                                        ...d,
                                        discount_type: d?.discount_type === SERVICE_TYPE["0"] ? SERVICE_TYPE["1"] : SERVICE_TYPE["0"]
                                    })
                                    setDiscountValues([...newDiscounts])
                                }}
                            >{d?.discount_type === SERVICE_TYPE["0"] ? "$" : "%"}</InputGroup.Text> */}
                            </Col>
                            {/* {index > 0 &&  */}
                            {/* } */}
                        </Row>
                    )
                })}
                {/* { addedRateSlabs?.length < rateSlabs?.length && 
                <Dropdown className="actions-menu">
					<Dropdown.Toggle className="dashed-border" id="dropdown-basic" size={"sm"}>
						+ {t("Add Range")}
					</Dropdown.Toggle>

					<Dropdown.Menu>
						{rateSlabs?.filter(rs => !addedRateSlabs?.map(ars => ars?.id).includes(rs?.id))?.map((range: Record<string, any>) =>
							<Dropdown.Item
								key={range?.id}
								onClick={() => {
                                    setAddedRateSlabs([...addedRateSlabs, rateSlabs?.find(rs => rs?.id === range?.id)])
                                    setAddedDiscounts([ 
                                        ...addedDiscounts, 
                                        { rate_slab_id: rateSlabs[addedRateSlabs?.length]?.id, rate_slab_discount: 0 }
                                    ])
                                    setDiscountValues([ 
                                        ...discountValues, 
                                        { rate_slab_id: rateSlabs[addedRateSlabs?.length]?.id, rate_slab_discount: 0 }
                                ])}}
							>
                                {`${range?.min_value} - ${range?.max_value} ${range?.weight_unit}`}
							</Dropdown.Item>
						)}
					</Dropdown.Menu>
				</Dropdown>
                } */}
            </td>
            <td className="col-1 d-flex align-items-start justify-content-between">
                <img
                    src={CheckIcon}
                    className="tr-pointer w-50 py-1"
                    onClick={() => {
                        if (!isEmpty(variationData)) {
                            const updatedData = {
                                ...variationData,
                                // shipping_service:
                                //     variationData?.service_identifier.toUpperCase().replaceAll(" ", "_"),
                                rate_slabs: [...discountValues]
                            }
                            handleSubmit(updatedData, "shipping-rates")
                            setSelectedWarehouse({})
                            setUpdateModalWarehouse(0)
                            setAddedRateSlabs([])
                            setDiscountValues([])
                            setVariationData({})
                        }
                    }}
                />
                <img
                    src={TrashIcon}
                    className="tr-pointer w-50 py-1 mx-1"
                    onClick={() => {
                        setShowConfirmModal("deleteShippingDiscount")
                    }}
                />
            </td>
        </tr>
    )
}

export default UpdateOrCreateShippingDiscount
